import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: "Verdana, 'Noto Sans Devanagari', Geneva, Tahoma, sans-serif",
  },
});

export default theme;
